// extracted by mini-css-extract-plugin
module.exports = {"Projects":"Projects_Projects__3Vg-u","Search":"Projects_Search__2ikZy","pagination":"Projects_pagination__2E3J3","active":"Projects_active__2NZIJ"};